import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { FormattedMessage } from "react-intl";
import Button from "../../../InformaAcademy/components/button";
import ControlledInput from "../../../../components/ControlledInputs/input";
import { FormRow } from "../../../../components/ControlledInputs/styles";
import Save from "../../../../icons/Save";
import BackIcon from "../../../../icons/Back";
import ControlledTextareaInput from "../../../../components/ControlledInputs/input-textarea";
import { HeaderContainer } from "../chapter/styles";
import { order, reorderArray } from "../chapter/chapter-form";

const schema = z.object({
  order: z.coerce.number().optional(),
  question: z.string().min(1).max(50, {
    message: "error.max_length-50",
  }),
  answer: z.string().min(1).max(260, {
    message: "error.max_length-260",
  }),
});

export default function EditFAQForm({ FAQ, setFAQ, defaultValue, resetModal }) {
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: defaultValue,
  });
  const { control, handleSubmit, formState, reset } = form;

  const handleReset = () => {
    reset();
    resetModal();
  };

  const onSubmit = async (data) => {
    if (defaultValue) {
      const findIndex = FAQ.findIndex((chapter) => {
        if (defaultValue.id) {
          return chapter.id === defaultValue.id;
        }
        return chapter.order === defaultValue.order;
      });
      if (findIndex !== -1) FAQ.splice(findIndex, 1);
    }

    const reorderedFAQ = reorderArray({
      array: [...FAQ],
      newItem: {
        question: data.question,
        answer: data.answer,
        order: order({
          array: FAQ,
          order: data.order,
        }),
        id: defaultValue.id ?? undefined,
      },
    });

    setFAQ(reorderedFAQ);
    handleReset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} key={Math.random()}>
      <HeaderContainer>
        <p>
          <FormattedMessage id={"manual_FAQ_edit"} />
        </p>
      </HeaderContainer>
      <FormRow marginBottom={"24px"}>
        <ControlledInput
          name={"question"}
          control={control}
          formState={formState}
          label={"question"}
          required={true}
          max={50}
          description={"FAQ_question_sub"}
        />
        <ControlledInput
          name={"order"}
          control={control}
          formState={formState}
          label={"lesson_order"}
          inputMode="numeric"
          min={1}
        />
      </FormRow>
      <FormRow marginBottom={"24px"}>
        <ControlledTextareaInput
          name={"answer"}
          control={control}
          formState={formState}
          label={"answer"}
          description={"FAQ_answer_sub"}
          required={true}
          min={1}
          max={260}
        />
      </FormRow>
      <FormRow buttons>
        <Button
          label={"goback"}
          variant={"secondary"}
          Icon={<BackIcon />}
          type={"button"}
          onClick={() => {
            handleReset();
          }}
        />
        <Button label={"save"} Icon={<Save />} />
      </FormRow>
    </form>
  );
}
